import { render, staticRenderFns } from "./TC.vue?vue&type=template&id=c1ba1c90&"
import script from "./TC.vue?vue&type=script&lang=js&"
export * from "./TC.vue?vue&type=script&lang=js&"
import style0 from "./TC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports